<script lang="ts">import Section from '../Section/Section.svelte';
import { headerAlignmentMap, variantMap, verticalAlignmentMap } from './helpers';
const { colorMode = 'light', variant = 'center', 
// verticalAlignment only works if the variant is left because it is aligning Section's heading and ctaItems and
// that is the only variant where they are on the same horizontal line
verticalAlignment = 'middle', headingText = '', headingLevel = 'h2', 
// headingSize changes the variant of Section because the only different between Section's primary and secondary
// variant is the size of the headingText
headingSize = 'large', ctaItems: ctaItemsFromProps, children, class: className = '', ...rest } = $props();
const closingCtaProps = $derived({
    ...rest,
    class: `ClosingCta ClosingCta--${variant} ${className}`,
    colorMode,
    variant: variantMap[headingSize ?? 'large'],
    headingText,
    headingLevel,
    headerAlignment: headerAlignmentMap[variant ?? 'center'],
    style: `--closing-cta-vertical-alignment: ${verticalAlignmentMap[verticalAlignment ?? 'middle']}`,
});
</script>

{#if ctaItemsFromProps && children}
  <Section {...closingCtaProps}>
    {#snippet ctaItems()}
      {@render ctaItemsFromProps?.()}
    {/snippet}
    {@render children?.()}
  </Section>
{:else if ctaItemsFromProps}
  <Section {...closingCtaProps}>
    {#snippet ctaItems()}
      {@render ctaItemsFromProps?.()}
    {/snippet}
  </Section>
{:else if children}
  <Section {...closingCtaProps}>
    {@render children?.()}
  </Section>
{:else}
  <Section {...closingCtaProps} />
{/if}

<style>/**
 * Do not edit directly, this file was auto-generated.
 * Fri, 01 Aug 2025 11:58:03 GMT
 */
/**
 We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
 */
@layer design-system-components.pwds {
  :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--primary) :global(.Section__slot-cta-items), :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--secondary) :global(.Section__slot-cta-items), :global(.ClosingCta--two-column.Section.Section-header-alignment--left.Section-variant--primary) :global(.Section__slot-cta-items), :global(.ClosingCta--two-column.Section.Section-header-alignment--left.Section-variant--secondary) :global(.Section__slot-cta-items) {
    grid-column: span 12;
  }
  @media (min-width: 46.25rem) {
    :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--primary) :global(.Section__header), :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--secondary) :global(.Section__header) {
      display: flex;
      justify-content: space-between;
      gap: var(--space-60);
    }
  }
  :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--primary) :global(.Section__slot-cta-items), :global(.ClosingCta--left.Section.Section-header-alignment--left.Section-variant--secondary) :global(.Section__slot-cta-items) {
    align-self: var(--closing-cta-vertical-alignment);
  }
  :global(.ClosingCta--two-column.Section.Section-header-alignment--left.Section-variant--primary) :global(.Section__slot-cta-items), :global(.ClosingCta--two-column.Section.Section-header-alignment--left.Section-variant--secondary) :global(.Section__slot-cta-items) {
    align-self: flex-start;
  }
  @media (min-width: 46.25rem) {
    :global(.ClosingCta--two-column) :global(.Section__header) {
      display: flex;
      justify-content: space-between;
    }
  }
  @media (min-width: 64rem) {
    :global(.ClosingCta--two-column) :global(.Section__header) {
      flex-direction: column;
      justify-content: start;
      grid-column: 1/span 6;
      width: 100%;
    }
  }
  @media (min-width: 64rem) {
    :global(.ClosingCta--two-column) :global(.Section__slot-default) {
      grid-column: 7/span 6;
    }
  }
  :global(.ClosingCta) :global(.Section__slot-cta-items) {
    align-items: center;
    flex-shrink: 0;
  }
  :global(.ClosingCta) :global(.Section__slot-default) {
    display: flex;
    flex-direction: column;
    gap: var(--space-40);
  }
  @media (min-width: 64rem) {
    :global(.ClosingCta) :global(.Section__slot-default) {
      gap: var(--space-60);
    }
  }
}</style>
